<!-- 用户选择画面 -->
<template>
  <j-modal title="选择" size="normal" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <UserManage ref="userManage" :isModal="true" :isMulti="params.isMulti"> </UserManage>
  </j-modal>
</template>
  
  <script>
import { putAction, postAction, getAction } from '@/api/manage'
import UserManage from '../UserManage.vue'

export default {
  name: 'SelectEmployee',
  components: { UserManage },
  props: {
    params: {
      type: Object,
      default: function () {
        return {
          // 是否多选
          isMulti: false,
          // 父组件
          parent: '',
          // 选中行
          selectionRows: [],
        }
      },
    },
  },
  data() {
    return {
      title: '',
      visible: false,
      loading: false,
      url: {},
    }
  },
  watch: {},
  created() {},
  methods: {
    handleOk() {
      if (this.$refs.userManage.selectionRows.length == 0) {
        return
      }

      this.$refs.userManage.selectionRows.forEach((r) => {
        r.value = r.id
        r.text = r.realname
      })

      this.$emit('emit', this.$refs.userManage.selectionRows)

      this.visible = false
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
  },
}
</script>
  
  <style scoped lang="less"></style>
  